import { toLuxon } from 'tdr-common';

export const epochToDisplayDateShort = (epochInSeconds: number, timezone: string, language?: string) => {
	const luxonDateTime = toLuxon(epochInSeconds, timezone).setLocale(language === 'fr' ? 'fr' : 'en');
	return luxonDateTime.toFormat('MMMM dd');
};